<template>
	<div class="list">
		<div class="title" @click="toggle(ishow,icon)">
			<i :class="icon"></i>
			{{title}}({{menus.length}})
		</div>
		<el-collapse-transition>
			<div v-show="ishow">
				<div
					:key="index"
					:class="item.isCheck?'transition-boxBack':'transition-box'"
					v-for="(item,index) in menu"
					@click="clickId(item)"
					@dblclick="AccessUsers(item)"
				>
					<div class="user">
						<span style="height:25px;display:inline-block">{{item.cousultNickName}}</span>
						<!-- <span :class="item.sysClass">{{item.sysStatus}}</span> -->
						<span v-if="item.isCheck && assemblyType=='1'" style="float:right">
							<a>正在会话...</a>
						</span>
						<span class="tips red" v-else-if="assemblyType=='1' && item.accessType==2">转单接入</span>
						<span
							class="tips green"
							v-else-if="assemblyType=='1' && (item.recentNewsTime==undefined || item.recentNewsTime==null) && ( item.kfLastSendTime==undefined && item.kfLastSendTime==null) && item.accessType!=2  "
						>新接入</span>
						<span
							class="tips green"
							v-else-if="assemblyType=='1'&& item.recentNewsTime!=undefined && item.unreadCount>0"
						>新消息</span>
						<span class="tips red" v-else-if="assemblyType=='3' && item.endTag=='超时结束'">超时结束</span>
						<span class="tips green" v-else-if="assemblyType=='3' && item.endTag=='手动结束'">手动结束</span>
						<span class="tips green" v-else-if="assemblyType=='3' && item.endTag=='咨询人结束'">咨询人结束</span>
						<span class="tips green" v-else-if="assemblyType=='3' && item.endTag=='未知'">未知</span>
					</div>
					<div class="from">
						<span>{{item.channelName}}</span>
						<span class="create_time" v-if="assemblyType==='2'">
							<timer
								autoStart
								:getDataFromChild="getDataFromChild()"
								:defaultVal="item.entryTimeMillisecond"
							/>
						</span>
						<span
							class="create_time"
							v-if="assemblyType==='1' && item.isCheck==false &&
							(item.kfLastSendTimeHM>item.recentNewsTimeHM || (item.kfLastSendTime!=undefined && item.recentNewsTime==undefined))
							 && (userConfig!=undefined && userConfig instanceof Array && userConfig.find(d=>d.id==4).selected==1)"
						>
							无响应时间
							<timer autoStart :getDataFromChild="getDataFromChild()" :defaultVal="item.kfLastSendTimeHM" />
						</span>
						<span class="create_time" style="color:red" v-if="item.unreadCount!=0 && assemblyType=='1'">
							{{getTimeVal(item.recentNewsTime)}}
							<el-badge :value="item.unreadCount>99?'99+':item.unreadCount" class="item"></el-badge>
						</span>
						<span
							class="create_time"
							v-if="assemblyType=='1' && item.recentNewsTimeHM && (item.unreadCount<1 || item.unreadCount==undefined) > item.kfLastSendTimeHM"
						>{{getTimeVal(item.recentNewsTime)}}</span>
						<span class="create_time" v-if="assemblyType=='3'">
							<el-tooltip class="item" effect="dark" content="会话结束时间" placement="top-start">
								<span>{{getTimeVal(item.offLineTime)}}</span>
							</el-tooltip>
						</span>
					</div>
				</div>
			</div>
		</el-collapse-transition>
	</div>
</template>
<script>
import timer from './timer'
import { FormatTimes } from '@/utils/FormatTime'
import { getMessa } from '@/components/customer/talks/ViewModel'
import { getUserConfigs } from '@/utils/GetUserConfig'
import { sortByKey, Sum } from '@/utils/utils'
export default {
	name: 'list',
	props: [],
	data() {
		return {
			ishow: this.isShow,
			icon: this.isIcon,
			time: '',
			menu: [],
			type: 1, //1 会话中 2 等待中 3 离线
			userConfig: []
		}
	},
	props: {
		title: {
			type: String,
			default: '会话中'
		},
		isShow: {
			type: Boolean,
			default: false
		},
		isIcon: {
			type: String,
			default: 'el-icon-caret-right'
		},
		menus: {
			type: Array,
			default: () => [
				{
					nickname: '用户1',
					status: '新消息',
					class: 'tips green',
					brand: '品牌-雀巢奶粉',
					create_time: '12:12:12'
				}
			]
		},
		assemblyType: {
			type: String,
			default: '1'
		}
	},
	watch: {
		updList() {
			this.list = this.updList
		},
		menus(val) {
			if (
				this.assemblyType == '1' &&
				val != undefined &&
				val.length > 0
			) {
				this.ishow = true
				this.icon = 'el-icon-caret-bottom'
			}
			if (
				this.assemblyType == '2' &&
				val != undefined &&
				val.length > 0
			) {
				this.ishow = true
				this.icon = 'el-icon-caret-bottom'
			}
			this.menu = val
		}
	},
	mounted: function() {
		this.list = this.updList
	},
	created: function() {
		this.userConfig = getUserConfigs()

		// this.init()
	},
	components: { timer },
	methods: {
		addList(data) {
			this.list[0].menus.push(data)
		},
		toggle(show, icon) {
			this.ishow = !show
			if (icon == 'el-icon-caret-right') {
				this.icon = 'el-icon-caret-bottom'
			} else {
				this.icon = 'el-icon-caret-right'
			}
		},
		getTimeVal(time) {
			return FormatTimes(time, 'hh:mm:ss')
		},
		clickId(item) {
			if (this.assemblyType !== '2') {
				this.menu.map(d => (d.isCheck = false))
				let index = this.menu.findIndex(
					d => d.cousultId == item.cousultId
				)
				var obj = new Object()
				obj.conversationLogId = item.conversationLogId
				obj.userConversationId = item.userConversationId
				obj.consultId = item.cousultId
				obj.dialogues = item.dialogues
				obj.entryTimeMillisecond = item.entryTimeMillisecond
				obj.accessChatId = item.accessChatId
				obj.cousultNickName = item.cousultNickName
				obj.unreadCount = item.unreadCount
				obj.assemblyType = this.assemblyType
				obj.entryTime = item.entryTime
				obj.transferRemarks = item.transferRemarks
				obj.channelName = item.channelName
				obj.accessType = item.accessType
				if (index > -1) {
					this.menu[index].isCheck = true
					this.menu[index].unreadCount = 0
				}
				this.$emit('cusultInfo', obj)
			}
		},
		getDataFromChild(val) {},
		nextCusultInfo() {
			let vm = this
			if (vm.menu[0] != undefined) {
				vm.menu[0].isCheck = true
				let item = vm.menu[0]
				var obj = new Object()
				obj.conversationLogId = item.conversationLogId
				obj.userConversationId = item.userConversationId
				obj.consultId = item.cousultId
				obj.dialogues = item.dialogues
				obj.entryTimeMillisecond = item.entryTimeMillisecond
				obj.accessChatId = item.accessChatId
				obj.cousultNickName = item.cousultNickName
				obj.unreadCount = item.unreadCount
				obj.assemblyType = this.assemblyType
				obj.entryTime = item.entryTime
				obj.transferRemarks = item.transferRemarks
				obj.channelName = item.channelName
				obj.accessType = item.accessType
				// var obj = new Object()
				// obj.conversationLogId = item.conversationLogId
				// obj.userConversationId = item.userConversationId
				// obj.consultId = item.cousultId
				// obj.dialogues = item.dialogues
				// obj.entryTimeMillisecond = item.entryTimeMillisecond
				// obj.accessChatId = item.accessChatId
				vm.$emit('cusultInfo', obj)
			} else {
				// this.$emit('cusultInfo', obj)
			}
			return 1
		},
		AccessUsers(val) {
			if (this.assemblyType === '2') {
				this.$emit(
					'manualAccess',
					val.cousultId,
					val.miniChannelId,
					val.awaitKey
				)
			}
		}
	}
}
</script>
<style scoped>
.title {
	height: 42px;
	line-height: 42px;
	background-color: #f2f3f5;
	font-size: 12px;
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: center;
	border-bottom: 1px solid #ddd;
	padding-left: 30px;
}
.title:hover {
	height: 42px;
	line-height: 42px;
	background-color: #f2f3f5;
	font-size: 12px;
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: center;
	border-bottom: 1px solid #ddd;
	padding-left: 30px;
	cursor: pointer;
}
.transition-box {
	padding: 10px 15px;
	border-bottom: 1px solid #eee;
}
.transition-box:hover {
	padding: 10px 15px;
	border-bottom: 1px solid #eee;
	background-color: #f2f3f5;
	cursor: pointer;
}
.transition-boxBack {
	padding: 10px 15px;
	border-bottom: 1px solid #eee;
	background-color: #d3d4d7;
	cursor: pointer;
}
.tips {
	float: right;
	border-radius: 15px;
	padding: 0 15px;
	cursor: pointer;
	font-size: 12px;
}
.tips.green {
	color: #fff;
	background-color: #047d0c;
}
.tips.red {
	color: #fff;
	background-color: #f74b55;
}
.tips.blue {
	color: #3781ff;
	padding: 0;
}
.user {
	line-height: 25px;
}
.from {
	margin-top: 10px;
}
.create_time {
	float: right;
}
.el-icon-caret-right {
	font-size: 16px;
	margin-right: 5px;
}
.el-icon-caret-bottom {
	font-size: 16px;
	margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/talks/list.vue